//This file is used for maintain JavaScript functions that are bound to a particular scope or view
(function(module) {
  'use strict';
  module
    .controller('travelSpendController', ['$scope', 'travelSpend', '$stateParams', 'progressBar', 'ngDialog',
      'clientSelectService', 'agencySelectService',
      'uiGridConstants', 'commonDialog', 'commonDialogMessage', '$filter', '$q', 'toastFactory', 'authService',
      function($scope, travelSpend, $stateParams, progressBar, ngDialog, clientSelectService, agencySelectService,
        uiGridConstants,
        commonDialog, commonDialogMessage, $filter, $q, toastFactory, authService) {
        let progress = progressBar.getProgressBar();
        $scope.dateCustFrom = new Date();
        $scope.dateCustTo = addMonth($scope.dateCustFrom); // Look ahead 1 month by default
        $scope.isCustomDate = false;
        $scope.isMonthDate = 'monthYear';
        let fromDate = null;
        let toDate = null;
        let selectedClientId = clientSelectService.getSelectedClient().id;

        function lastDayOfMonth(month, year) {
          return new Date(year, month, 0).toLocaleDateString().replace(/[^ -~]/g, '');
        };

        function firstDayOfMonth(month, year) {
          return new Date(year, month - 1, 1).toLocaleDateString().replace(/[^ -~]/g, '');
        };
        $scope.years = _.range(2010, 2099);

        function validateToDate(fromDate, toDate) {
          return (fromDate <= toDate);
        };

        function addMonth(startDate) {
          // Does not handle end-of-month edge case, e.g. Oct 31 + 1 month = Dec 01
          return new Date(new Date(startDate).setMonth(startDate.getMonth() + 1));
        }
        $scope.monthList = [{
          id: 1,
          name: 'January',
        }, {
          id: 2,
          name: 'February',
        }, {
          id: 3,
          name: 'March',
        }, {
          id: 4,
          name: 'April',
        }, {
          id: 5,
          name: 'May',
        }, {
          id: 6,
          name: 'June',
        }, {
          id: 7,
          name: 'July',
        }, {
          id: 8,
          name: 'August',
        }, {
          id: 9,
          name: 'September',
        }, {
          id: 10,
          name: 'October',
        }, {
          id: 11,
          name: 'November',
        }, {
          id: 12,
          name: 'December',
        }, ];
        $scope.monthDateSelected = function() {
          $scope.isCustomDate = false;
        };
		    $scope.yearName = new Date().getFullYear();
        $scope.monthId = new Date().getMonth() + 1;
        // Validate that filtered organization id is defined
        function validateOrganization() {
          const client = clientSelectService.getSelectedClient();
          return client.id != null && Number.isInteger(client.id);
        }
        $scope.searchTravelSpend = function() {
          setTravelSpend();
        };
        // Validate that filtered organization id is defined
        function validateAgencyAndClientSelection() {
          const agency = agencySelectService.getSelectedAgency();
          const client = clientSelectService.getSelectedClient();
          return {
            agencyValid: agency.id != null && Number.isInteger(agency.id),
            clientValid: client.id != null && Number.isInteger(client.id),
          };
        }

        function setTravelSpend() {
          if (authService.getLoginMember().Role === 3) {
            selectedClientId = authService.getLoginMember().OrganizationId;
            showCharts(selectedClientId);
          } else {
            const valid = validateAgencyAndClientSelection();
            if (valid.agencyValid && valid.clientValid) {
              selectedClientId = clientSelectService.getSelectedClient().id;
              showCharts(selectedClientId);
            } else if (valid.agencyValid) {
              // toastFactory.toast_info('Please select a client.');
            } else {
              // toastFactory.toast_info('Please select an agency and then client.');
            }
          }
        };

        function showCharts(selectedClientId) {
          if ($scope.isCustomDate) {
            fromDate = $filter('date')(($scope.dateCustFrom), 'yyyy-MM-dd').replace(/[^ -~]/g, '');
            toDate = $filter('date')(($scope.dateCustTo), 'yyyy-MM-dd').replace(/[^ -~]/g, '');
          } else {
            fromDate = $filter('date')(new Date(firstDayOfMonth($scope.monthId, $scope.yearName)),
              'yyyy-MM-dd');
            toDate = $filter('date')(new Date(lastDayOfMonth($scope.monthId, $scope.yearName)),
              'yyyy-MM-dd');
          };
          // const organization = clientSelectService.getSelectedClient();
          if (validateToDate(fromDate, toDate)) {
            // Show charts -- DOM must be unhidden early enough for Chartist to be able to draw items upon
            $scope.showCharts = true;
            progress.start();
            const promiseTotalSpend = travelSpend.getTotalSpendByDates(fromDate, toDate, selectedClientId);
            const promiseTopAirline = travelSpend.getTopAirlines(fromDate, toDate, selectedClientId);
            const promiseTopHotel = travelSpend.getTopHotels(fromDate, toDate, selectedClientId);
            const promiseCarRental = travelSpend.getTopCarRentalCompanies(fromDate, toDate, selectedClientId);
            const promiseCityPairs = travelSpend.getTopCityPairs(fromDate, toDate, selectedClientId);
            $q.all([promiseTotalSpend, promiseTopAirline, promiseTopHotel, promiseCarRental, promiseCityPairs])
              .then(
                function(response) {
                  let totalSpendContext = response[0].data;
                  let topAirlineContext = response[1].data;
                  let topHotelContext = response[2].data;
                  let carRentalContext = response[3].data;
                  let cityPairsContext = response[4].data;
                  totalSpendBreakdownYTD(totalSpendContext);
                  generateTopAirlines(topAirlineContext);
                  generateTopHotels(topHotelContext);
                  generateTopCarRentalCompanies(carRentalContext);
                  getTopCityPairs(cityPairsContext);
                },
                function(err) {
                  if (err.status != 401) {
                    ngDialog.open({
                      template: 'templates/partials/viewErrorMsg.html',
                      className: 'ngdialog-theme-plain',
                      controller: ['$scope', function($scope) {
                        $scope.errMsg = `<p>${err.statusText}</p>`;
                        $scope.errTitle = 'Travel spend Error'; //PLACE HOLDER
                      }, ],
                    });
                  }
                })
              .finally(function() {
                progress.complete();
              });
          } else {
            //toastFactory.toast_warn(commonDialogMessage.dateErrorMessage);
          };
        }
        //on page load shwoing data in grid
        setTravelSpend();
        // Watch clientSelectService for changes to getFilteredOrganization() output -- expensive, calls getFilteredOrganization many times during $digest cycle
        $scope.$watch(function() {
          return clientSelectService.getSelectedClient();
        }, function(newValue, oldValue) {
          if (newValue !== oldValue) {
            // Destroy old charts
            destroyCharts();
            // Clear ui-grid
            $scope.gridOptions.data = [];
            $scope.gridOptions.totalItems = 0;
            // Show/hide charts
            if (validateOrganization()) {
              // Redundancy
              $scope.showCharts = true;
            } else {
              $scope.showCharts = false;
            }
            // Re-fetch charts
            setTravelSpend();
          }
        }, true);
        // Programmatically destroy Chartist objects -- very brute-force for now
        function destroyCharts() {
          const charts = [
            $scope.totalSpendChart,
            $scope.topAirlineChart,
            $scope.topAirlineDomChart,
            $scope.topAirlineIntChart,
            $scope.topHotelChart,
            $scope.topCarRentalChart,
          ].forEach(function(apiObj) {
            if (apiObj) {
              apiObj.detach();
            }
          });
          const containers = [
            $('#chartTotalSpend'),
            $('#chartTopAirline'),
            $('#chartTopAirlineDom'),
            $('#chartTopAirlineInt'),
            $('#chartTopHotel'),
            $('#chartTopCities'),
          ].forEach(function(container) {
            container.empty();
          });
          $scope.isTotalSpendData = false;
          $scope.isTopCombAirData = false;
          $scope.isTopDomAirData = false;
          $scope.isTopIntAirData = false;
          $scope.isTopHotelData = false;
          $scope.isTopCarRentalData = false;
        };

        function totalSpendBreakdownYTD(totalSpendContext) {
          let totalSpendSeriesList = totalSpendContext.filter(function(totalSpend) {
            return (!!totalSpend.Name);
          }).map(function(totalSpend) {
            return {
              value: totalSpend.Amount,
            };
          });
          let totalSpendLabelList = totalSpendContext.filter(function(totalSpend) {
            return (!!totalSpend.Name);
          }).map(function(totalSpend) {
            return totalSpend.Name;
          });
          // assign data to chart
          const dataTotalSpend = {
            labels: totalSpendLabelList,
            series: [totalSpendSeriesList],
          };
          let totalSpendCount = totalSpendContext.filter(function(totalSpend) {
            return (!!totalSpend.Amount);
          });
          if (!!totalSpendCount.length) {
            $scope.isTotalSpendData = true;
          } else {
            $scope.isTotalSpendData = false;
          }
          $scope.totalSpendChart = new Chartist.Bar('#chartTotalSpend', dataTotalSpend, {
            seriesBarDistance: 15,
            height: 650,
            reverseData: true,
            horizontalBars: true,
            axisY: {
              offset: 120,
            },
            axisX: {
              offset: 320,
              labelInterpolationFnc: function(value) {
                return '$' + value.toFixed(0);
              },
            },
            plugins: [
              Chartist.plugins.ctBarLabels({
                labelClass: 'ct-labelBar',
                labelInterpolationFnc: function(value) {
                  return '$' + value.toFixed(0);
                },
              }),
            ],
          }).on('draw', (ctx) => {
            if (ctx.type === 'label') {
              const dX = ctx.width / 2 + (100 - ctx.width);
              ctx.element.attr({
                x: ctx.element.attr('x') - dX,
              });
            };
            if (ctx.type === 'bar') {
              ctx.element.attr({
                style: 'stroke-width: 20px',
              });
            };
          });
        };

        function generateTopAirlines(topAirlineContext) {
          //for top combine airline chart
          let topAirlinesComContext = topAirlineContext[0];
          generateTopCombineAir(topAirlinesComContext);
          //for top domestic airline chart
          let topAirlinesDomContext = topAirlineContext[1];
          generateTopDomesticAir(topAirlinesDomContext);
          //for International airline chart
          let topAirlinesIntContext = topAirlineContext[2];
          generateTopIntAir(topAirlinesIntContext);
        };

        function generateTopCombineAir(topAirlinesComContext) {
          let totalCombine = 0;
          let topAirlineCombSerList;
          let topAirlineCombSeriesList = topAirlinesComContext.filter(function(topAirline) {
            return ((topAirline.Name == 'Combined') && (!!topAirline.Airline));
          }).map(function(topAirline) {
            return {
              name: topAirline.Airline,
              value: topAirline.Segments,
            };
          });
          totalCombine = topAirlineCombSeriesList.reduce(function(totalSegments, element) {
            return totalSegments += element.value;
          }, totalCombine);
          //calculate list of other catergory
          let topAirlineOtherList = topAirlineCombSeriesList.filter(function(topAirline) {
            return ((Math.round(topAirline.value / totalCombine *
              100)) <= 5);
          });
          let totalOtherCategory = 0;
          totalOtherCategory = topAirlineOtherList.reduce(function(totalSegments, element) {
            return totalSegments += element.value;
          }, totalOtherCategory);
          //calculate list of top catergory
          let topAirlineList = topAirlineCombSeriesList.filter(function(topAirline) {
            return ((Math.round(topAirline.value / totalCombine *
              100)) > 5);
          });
          if (!!totalOtherCategory) {
            topAirlineCombSerList = _.concat(topAirlineList, {
              name: 'Others (less than 5%)',
              value: totalOtherCategory,
            });
          } else {
            topAirlineCombSerList = topAirlineList;
          }
          let topAirlinesCombLabelList = topAirlineCombSerList.map(function(element) {
            return element.name;
          });
          $scope.isTopCombAirData = ((!!topAirlineCombSerList.length) ? true : false);
          // assign data to chart
          const dataTopAirline = {
            labels: topAirlinesCombLabelList,
            series: topAirlineCombSerList,
          };
          $scope.topAirlineChart = new Chartist.Pie('#chartTopAirline', dataTopAirline, {
            labelInterpolationFnc: function(label, index) {
              return Math.round(dataTopAirline.series[index].value / totalCombine *
                100) + '%';
            },
            width: 250,
            height: 250,
            chartPadding: 5,
            labelOffset: 37,
            labelDirection: 'explode',
            plugins: [
              Chartist.plugins.legend({
                clickable: false,
              }),
            ],
          }).on('draw', function(context) {
            if (context.type === 'slice') {
              var $slice = $(context.element._node);
              $slice.tooltipster({
                content: $slice.parent().attr('ct:series-name') + ' ' + $slice.attr(
                  'ct:value') + ' ' + 'segments',
              });
            }
          });
        };

        function generateTopDomesticAir(topAirlinesDomContext) {
          let totalDom = 0;
          let topDomesticSerList;
          let topAirlineDomesticSerList = topAirlinesDomContext.filter(function(topDomAirline) {
            return ((topDomAirline.Name == 'Domestic') && (!!topDomAirline.Airline));
          }).map(function(topDomAirline) {
            return {
              name: topDomAirline.Airline,
              value: topDomAirline.Segments,
            };
          });
          totalDom = topAirlineDomesticSerList.reduce(function(totalSegments, element) {
            return totalSegments += element.value;
          }, totalDom);
          //calculate list of other catergory
          let topDomesticOtherList = topAirlineDomesticSerList.filter(function(topAirline) {
            return ((Math.round(topAirline.value / totalDom *
              100)) <= 5);
          });
          let totalOtherCategory = 0;
          totalOtherCategory = topDomesticOtherList.reduce(function(totalSegments, element) {
            return totalSegments += element.value;
          }, totalOtherCategory);
          //calculate list of top catergory
          let topDomesticList = topAirlineDomesticSerList.filter(function(topAirline) {
            return ((Math.round(topAirline.value / totalDom *
              100)) > 5);
          });
          if (!!totalOtherCategory) {
            topDomesticSerList = _.concat(topDomesticList, {
              name: 'Others (less than 5%)',
              value: totalOtherCategory,
            });
          } else {
            topDomesticSerList = topDomesticList;
          }
          let topDomesticLblList = topDomesticSerList.map(function(element) {
            return element.name;
          });
          $scope.isTopDomAirData = ((!!topDomesticSerList.length) ? true : false);
          // assign data to chart
          let dataTopAirlineDom = {
            labels: topDomesticLblList,
            series: topDomesticSerList,
          };
          $scope.topAirlineDomChart = new Chartist.Pie('#chartTopAirlineDom', dataTopAirlineDom, {
            labelInterpolationFnc: function(label, index) {
              return Math.round(dataTopAirlineDom.series[index].value / totalDom * 100) + '%';
            },
            width: 140,
            height: 140,
            chartPadding: 5,
            labelOffset: 12,
            labelDirection: 'explode',
            plugins: [
              Chartist.plugins.legend({
                className: 'ct-legend-inside-air',
                clickable: false,
              }),
            ],
          }).on('draw', function(context) {
            if (context.type === 'slice') {
              var $slice = $(context.element._node);
              $slice.tooltipster({
                content: $slice.parent().attr('ct:series-name') + ' ' + $slice.attr(
                  'ct:value') + ' ' + 'segments',
              });
            }
          });
        };

        function generateTopIntAir(topAirlinesIntContext) {
          let totalInt = 0;
          let topIntSerList;
          let topAirlineInteSerList = topAirlinesIntContext.filter(function(topIntAirline) {
            return ((topIntAirline.Name == 'International') && (!!topIntAirline.Airline));
          }).map(function(topIntAirline) {
            return {
              name: topIntAirline.Airline,
              value: topIntAirline.Segments,
            };
          });
          totalInt = topAirlineInteSerList.reduce(function(totalSegments, element) {
            return totalSegments += element.value;
          }, totalInt);
          //calculate list of other catergory
          let topIntOtherList = topAirlineInteSerList.filter(function(topAirline) {
            return ((Math.round(topAirline.value / totalInt *
              100)) <= 5);
          });
          let totalOtherCategory = 0;
          totalOtherCategory = topIntOtherList.reduce(function(totalSegments, element) {
            return totalSegments += element.value;
          }, totalOtherCategory);
          //calculate list of top catergory
          let topIntList = topAirlineInteSerList.filter(function(topAirline) {
            return ((Math.round(topAirline.value / totalInt *
              100)) > 5);
          });
          if (!!totalOtherCategory) {
            topIntSerList = _.concat(topIntList, {
              name: 'Others (less than 5%)',
              value: totalOtherCategory,
            });
          } else {
            topIntSerList = topIntList;
          }
          let topIntLabelList = topIntSerList.map(function(element) {
            return element.name;
          });
          $scope.isTopIntAirData = ((!!topIntSerList.length) ? true : false);
          // assign data to chart
          let dataTopAirlineInt = {
            labels: topIntLabelList,
            series: topIntSerList,
          };
          $scope.topAirlineIntChart = new Chartist.Pie('#chartTopAirlineInt', dataTopAirlineInt, {
            labelInterpolationFnc: function(label, index) {
              return Math.round(dataTopAirlineInt.series[index].value / totalInt * 100) + '%';
            },
            width: 140,
            height: 140,
            chartPadding: 5,
            labelOffset: 12,
            labelDirection: 'explode',
            plugins: [
              Chartist.plugins.legend({
                className: 'ct-legend-inside-air',
                clickable: false,
              }),
            ],
          }).on('draw', function(context) {
            if (context.type === 'slice') {
              var $slice = $(context.element._node);
              $slice.tooltipster({
                content: $slice.parent().attr('ct:series-name') + ' ' + $slice.attr(
                  'ct:value') + ' ' + 'segments',
              });
            }
          });
        };

        function generateTopHotels(hotelNightsContext) {
          let totalHotelNights = 0;
          let topHotelSerList;
          let topHotelSeriesList = hotelNightsContext.filter(function(topHotel) {
            return (!!topHotel.HotelName && !!topHotel.NumberOfNights);
          }).map(function(topHotel) {
            return {
              name: topHotel.HotelName,
              value: topHotel.NumberOfNights,
            };
          });
          totalHotelNights = topHotelSeriesList.reduce(function(totalNights, element) {
            return totalNights += element.value;
          }, totalHotelNights);
          //calculate list of other catergory
          let topHotelOtherList = topHotelSeriesList.filter(function(topHotel) {
            return ((Math.round(topHotel.value / totalHotelNights *
              100)) <= 5);
          });
          let totalOtherCategory = 0;
          totalOtherCategory = topHotelOtherList.reduce(function(totalNights, element) {
            return totalNights += element.value;
          }, totalOtherCategory);
          //calculate list of top catergory
          let topHotelList = topHotelSeriesList.filter(function(topHotel) {
            return ((Math.round(topHotel.value / totalHotelNights *
              100)) > 5);
          });
          if (!!totalOtherCategory) {
            topHotelSerList = _.concat(topHotelList, {
              name: 'Others (less than 5%)',
              value: totalOtherCategory,
            });
          } else {
            topHotelSerList = topHotelList;
          }
          let topHotelLabelList = topHotelSerList.map(function(element) {
            return element.name;
          });
          if (topHotelLabelList.length > 7) {
            $("#chartTopHotel").css({
              "margin-left": "10px"
            });  
          } else {
            $("#chartTopHotel").css({
              "margin-left": "280px"
            });
          }
          $scope.isTopHotelData = ((!!topHotelSerList.length) ? true : false);
          // assign data to chart
          const dataHotel = {
            labels: topHotelLabelList,
            series: topHotelSerList,
          };
          $scope.topHotelChart = new Chartist.Pie('#chartTopHotel', dataHotel, {
            labelInterpolationFnc: function(label, index) {
              return Math.round(dataHotel.series[index].value / totalHotelNights * 100) + '%';
            },
            width: 250,
            height: 250,
            chartPadding: 5,
            labelOffset: 37,
            plugins: [
              Chartist.plugins.legend({
                clickable: false,
              }),
            ],
          }).on('draw', function(context) {
            if (context.type === 'slice') {
              var $slice = $(context.element._node);
              $slice.tooltipster({
                content: $slice.parent().attr('ct:series-name') + ' ' + $slice.attr(
                  'ct:value') + ' ' + 'room nights',
              });
            }
          });
        };

        function generateTopCarRentalCompanies(carRentalContext) {
          let totalNumberofDays = 0;
          let topCarRentalSerList;
          let topCarRentalSeriesList = carRentalContext.filter(function(carRental) {
            return (!!carRental.RentalCompany && !!carRental.NumberOfDays);
          }).map(function(carRental) {
            return {
              name: carRental.RentalCompany,
              value: carRental.NumberOfDays,
            };
          });
          totalNumberofDays = topCarRentalSeriesList.reduce(function(totalDays, element) {
            return totalDays += element.value;
          }, totalNumberofDays);
          //calculate list of other catergory
          let topCarRentalOtherList = topCarRentalSeriesList.filter(function(topCarRental) {
            return ((Math.round(topCarRental.value / totalNumberofDays *
              100)) <= 5);
          });
          let totalOtherCategory = 0;
          totalOtherCategory = topCarRentalOtherList.reduce(function(totalNights, element) {
            return totalNights += element.value;
          }, totalOtherCategory);
          //calculate list of top catergory
          let topCarRentalList = topCarRentalSeriesList.filter(function(topCarRental) {
            return ((Math.round(topCarRental.value / totalNumberofDays *
              100)) > 5);
          });
          if (!!totalOtherCategory) {
            topCarRentalSerList = _.concat(topCarRentalList, {
              name: 'Others (less than 5%)',
              value: totalOtherCategory,
            });
          } else {
            topCarRentalSerList = topCarRentalList;
          }
          let topCarRentalLabelList = topCarRentalSerList.map(function(element) {
            return element.name;
          });
          $scope.isTopCarRentalData = ((!!topCarRentalSerList.length) ? true : false);
          // assign data to chart
          const dataTopCarRental = {
            labels: topCarRentalLabelList,
            series: topCarRentalSerList,
          };
          $scope.topCarRentalChart = new Chartist.Pie('#chartTopCities', dataTopCarRental, {
            labelInterpolationFnc: function(label, index) {
              return Math.round(dataTopCarRental.series[index].value / totalNumberofDays * 100) + '%';
            },
            width: 250,
            height: 250,
            chartPadding: 5,
            labelOffset: 37,
            plugins: [
              Chartist.plugins.legend({
                clickable: false,
              }),
            ],
          }).on('draw', function(context) {
            if (context.type === 'slice') {
              var $slice = $(context.element._node);
              $slice.tooltipster({
                content: $slice.parent().attr('ct:series-name') + ' ' + $slice.attr(
                  'ct:value') + ' ' + 'days',
              });
            }
          });
        };
        // ui-grid code for generate top city pairs
        const paginationOptions = {
          pageNumber: 1,
          pageSize: 25,
          sort: null,
        };
        $scope.gridOptions = {
          paginationPageSizes: [5, 10, 25, 50],
          enableFiltering: true,
          enableGridMenu: true,
          paginationPageSize: 25,
          useExternalPagination: false,
          useExternalSorting: false,
          enableColumnResizing: true,
          columnDefs: [{
            name: 'Cities',
            visible: true,
            displayName: 'City Pair',
            enableHiding: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableSorting: true,
            enableFiltering: true,
            enableColumnResizing: true,
            maxWidth: 250,
          }, {
            name: 'Segments',
            visible: true,
            displayName: 'Segments',
            enableHiding: true,
            type: 'number',
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableSorting: true,
            enableFiltering: true,
            enableColumnResizing: true,
            maxWidth: 250,
          }, {
            name: 'Volume',
            visible: true,
            displayName: 'Volume',
            type: 'number',
            enableHiding: true,
            enableSorting: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableFiltering: true,
            enableColumnResizing: true,
            maxWidth: 250,
          }, {
            name: 'LeadingCarrier',
            visible: true,
            displayName: 'Leading Carrier',
            enableHiding: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableSorting: true,
            enableFiltering: true,
            enableColumnResizing: true,
            maxWidth: 250,
          }, {
            name: 'LeadingCarrierSegments',
            visible: true,
            displayName: 'Leading Carrier Segments',
            type: 'number',
            enableHiding: true,
            enableSorting: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableFiltering: true,
            enableColumnResizing: true,
            maxWidth: 250,
          }, {
            name: 'SegmentMarketShare',
            visible: true,
            displayName: 'Segment Market Share',
            type: 'number',
            enableHiding: false,
            enableSorting: true,
            enableFiltering: true,
            enableColumnResizing: true,
            maxWidth: 250,
          }, ],
          onRegisterApi: function(gridApi) {
            $scope.gridApi = gridApi;
            $scope.gridApi.core.on.sortChanged($scope, function(grid, sortColumns) {
              if (!sortColumns.length) {
                paginationOptions.sort = null;
              } else {
                paginationOptions.sort = sortColumns[0].sort.direction;
              }
            });
            gridApi.pagination.on.paginationChanged($scope, function(newPage, pageSize) {
              paginationOptions.pageNumber = newPage;
              paginationOptions.pageSize = pageSize;
            });
          },
        };

        function getTopCityPairs(topCityPairsContext) {
          const firstRow = (paginationOptions.pageNumber - 1) * paginationOptions.pageSize;
          $scope.gridOptions.data = topCityPairsContext.slice(firstRow, firstRow + paginationOptions.pageSize);
          $scope.gridOptions.totalItems = topCityPairsContext.length;
        };
      },
    ]);
})(angular.module('obex'));


// WEBPACK FOOTER //
// ./client/js/controllers/travelSpendController.js